<div class="notification_request_left">
  <div class="notification_request_text">
    <div class="notification_request_title">
      برای ارسال پیامک یادآوری شماره موبایل خود را وارد کنید.
    </div>
    <div class="notification_request_description">
      <input class="reminder_mobile" type="text" placeholder="091234567" [(ngModel)]="user.mobile">
    </div>
  </div>
  <div class="dismiss_btn" (click)="closeDialog()">
    &times;
  </div>
  <button class="notification_request_button accept-btn" (click)="addPhoneNumber()">ثبت</button>
</div>
